module.exports = __webpack_public_path__ + "img/199-Gris Quartz Lisse.jpg";